import { render, staticRenderFns } from "./FleetView.vue?vue&type=template&id=24b3b84c&"
import script from "./FleetView.vue?vue&type=script&lang=js&"
export * from "./FleetView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports